import { render, staticRenderFns } from "./ImgViewZoom.vue?vue&type=template&id=b15fd554&scoped=true&"
import script from "./ImgViewZoom.vue?vue&type=script&lang=js&"
export * from "./ImgViewZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImgViewZoom.vue?vue&type=style&index=0&id=b15fd554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15fd554",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ImgViewZoom.vue
// module id = 370
// module chunks = 0